<template>
    <div class="block-child">
        <BlockParallax
            class="block-child__icon block-child__icon-vane"
            speed="10"
            direction="right"
            transform="rotate"
            fixed>
            <img src="@/assets/images/icons/vane.svg">
        </BlockParallax>
        <BlockParallax
            class="block-child__icon block-child__icon-cloud-one"
            speed="10"
            direction="right"
            transform="translateX"
            fixed>
            <img src="@/assets/images/icons/cloud-2.svg">
        </BlockParallax>
        <BlockParallax
            class="block-child__icon block-child__icon block-child__icon-cloud-two"
            speed="14"
            direction="right"
            transform="translateX"
            fixed>
            <img src="@/assets/images/icons/cloud-2.svg">
        </BlockParallax>
        <BlockParallax
            class="block-child__icon block-child__icon-cloud-three block-child--icon-desktop"
            speed="12"
            direction="right"
            transform="translateX"
            fixed>
            <img src="@/assets/images/icons/cloud-2.svg">
        </BlockParallax>

        <img
            srcset="../assets/7-img.jpg, ../assets/7-img@2x.jpg 2x"
            src="../assets/7-img.jpg"
            class="block-child__img"
        >
        <div class="image-caption image-caption--overlap-right">Территория детского сада в&nbsp;проекте<br class="no-mobile"> «Бунинские луга»</div>

        <BlockParallax
            class="block-child__content"
            fixed
            speed="8"
            direction="top"
            transform="translateY"
        >
            <span class="block-child__title">Ребенок и мир</span>
            <p class="block-child__text">
                Трехлетний ребенок готов впустить в свой мир других взрослых и хочет больше общения со сверстниками. В
                это время большинство детей идут в детский сад.
            </p>
        </BlockParallax>
        <div class="block-child__road">
            <BlockParallax class="block-child__road__icon" speed="4" transform="animate5" fixed>
                <img src="@/assets/images/icons/car-3.png">
            </BlockParallax>
        </div>
    </div>
</template>

<script>
import BlockParallax from '@/components/blocks/parallax'

export default {
    components: {
        BlockParallax
    }
}
</script>

<style scoped lang="stylus">
    .block-child {
        margin-top 3rem
        margin-left -1rem
        margin-right -1rem
        font-size 0
        position relative

        +layout-sm-and-up() {
            margin-left 0
            margin-right 0
        }
        +layout-md-and-up() {
            margin-top 5rem
        }

        &__img {
            position relative
            z-index 4
            object-fit contain
            +layout-sm-and-up() {
                max-width 100%
            }

            +layout-xs() {
                width 100%
                height 355px
                object-fit cover
            }
        }

        &__content {
            position relative
            max-width 46rem
            background-color $color-yellow
            padding 2rem 2rem 3rem 2rem
            margin-left 4rem
            margin-top -10rem
            z-index 5
            +layout-sm-and-up() {
                margin-left auto
                margin-right 8rem
            }
            +layout-md-and-up() {
                padding 4rem 6rem
                padding-bottom 7rem
                margin -8rem auto 0 8rem
                position relative
            }
        }

        &__title {
            font-size 2.2rem
            line-height 2.6rem
            font-weight $font-semiBold
            color $color-white
            +layout-md-and-up() {
                font-size 3rem
            }
        }

        &__text {
            color $color-text
            font-size 1.5rem
            line-height 1.47
            margin 1.6rem 0 0 0
        }

        &__icon {
            position absolute
        }

        &--icon-desktop {
            display none
            +layout-md-and-up() {
                display block
            }
        }

        &__icon-vane {
            z-index 100
            position absolute
            right -20px
            top -59px
            width 12rem
            height 12rem
            +layout-md-and-up() {
                right 0
                top -16.6rem
                width 20rem
                height 20rem
            }
        }

        &__icon-cloud-one {
            bottom 232px
            left -35px
            width 12rem
            z-index 100
            +layout-md-and-up() {
                left -11.6rem
                top 20.4rem
                width 26rem
                height 9rem
            }

        }

        &__icon-cloud-two {
            z-index 100
            right -4rem
            bottom 20.7rem
            width 12rem
            +layout-md-and-up() {
                right 10.3rem
                top -4.5rem
                width 19rem
                height 9.1rem
            }
        }

        &__icon-cloud-three {
            z-index 100
            right - 17.7rem
            top 14.1rem
            width 21.9rem
            height 10rem
        }

        &__road {
            display none
            +layout-md-and-up() {
                display block
                position absolute
                height 63rem
                background-image url('~@/assets/images/icons/road-4.png')
                bottom -31.4rem
                width 100vw
                left 50%
                transform translateX(-50%)
                background-size 144rem
                background-repeat no-repeat
                background-position left bottom
            }
            @media (min-width: 1440px) {
                width 144rem
                left 50%
                background-position center bottom
            }
            &__icon {
                position absolute
                left 9rem
                bottom 15.3rem
                -webkit-transform rotate(20deg)
                transform rotate(1deg)
            }

        }
    }
</style>
